// const { version, name } = this.experienceMetadata;
// const { segment } = this.context.request || {};
// const { storeId } = this.context.localStore || {};
// if (window.newrelic && name && version) {
//   window.newrelic.setCustomAttribute('canary', version);
//   window.newrelic.addRelease(name, version);
//   window.newrelic.setCustomAttribute('segment', segment);
//   window.newrelic.setCustomAttribute('storeId', storeId);
//   setTimeout(() => {
//     if (typeof window.testversion !== 'undefined') {
//       window.newrelic.setCustomAttribute('tnt', window.testversion);
//     }
//   }, 4000);
// }

export const customVariables = () => {
  if (typeof window !== 'undefined') {
    const { version, name } = window.experienceMetadata || {};
    if (window.newrelic && name && version) {
      window.newrelic.setCustomAttribute('expVersion', version);
      window.newrelic.setCustomAttribute('expName', name);
      window.newrelic.addRelease(name, version);
      setTimeout(() => {
        if (typeof window.testversion !== 'undefined') {
          window.newrelic.setCustomAttribute('tnt', window.testversion);
        }
      }, 4000);
    }
  }

  window.LIFE_CYCLE_EVENT_BUS.lifeCycle.on('experience-context.ready', ({ output }) => {
    const { store, clientStore, segment, customer } = output || {};
    const storeId = clientStore?.storeId || store?.storeId;
    const { type: customerType, localizationStatus } = customer || {};
    if (typeof window !== 'undefined' && window.newrelic) {
      if (segment) {
        window.newrelic.setCustomAttribute('segment', segment);
      }
      if (storeId) {
        window.newrelic.setCustomAttribute('storeId', storeId);
      }
      if (customerType) {
        window.newrelic.setCustomAttribute('customerType', customerType);
      }
      if (localizationStatus) {
        window.newrelic.setCustomAttribute('localizationStatus', localizationStatus);
      }
    }
  });
};
